import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, clsx, Popover } from '@a-type/ui';
import { withGame } from '@long-game/game-client';
import { Suspense } from 'react';
import { ChatForm } from './ChatForm.js';
import { ChatLog } from './ChatLog.js';
import cls from './SpatialChatThread.module.css';
function SvgTrigger({ className, latestMessage, ref, ...rest }) {
    if (latestMessage) {
        return (_jsx(Box, { layout: "center center", className: clsx(cls.latest, className), render: _jsx("g", { ref: ref }), color: "accent", surface: "primary", border: true, ...rest, children: _jsx("g", { className: cls.touchTarget }) }));
    }
    return _jsx("g", { className: className, ref: ref, ...rest });
}
function DomTrigger({ className, latestMessage, ...rest }) {
    if (latestMessage) {
        return (_jsx(Box, { layout: "center center", className: clsx(cls.latest, className), color: "accent", surface: "primary", border: true, ...rest, children: _jsx("div", { className: cls.touchTarget }) }));
    }
    return _jsx("div", { className: className, ...rest });
}
export const SpatialChatThread = withGame(function ChatThread({ className, chats, open, onOpenChange, sceneId, position, svg, }) {
    const latestMessage = chats[chats.length - 1];
    return (_jsxs(Popover, { open: open, onOpenChange: onOpenChange, children: [_jsx(Popover.Trigger, { className: cls.trigger, render: svg ? (_jsx(SvgTrigger, { className: className, latestMessage: latestMessage })) : (_jsx(DomTrigger, { className: className, latestMessage: latestMessage })) }), _jsx(Suspense, { children: _jsxs(Popover.Content, { side: "bottom", className: cls.popover, children: [_jsx(Popover.Arrow, {}), _jsx(ChatLog, { log: chats.map((chat) => ({
                                type: 'chat',
                                chatMessage: chat,
                                timestamp: chat.createdAt,
                            })), className: cls.log }), _jsx(ChatForm, { className: cls.form, sceneId: sceneId, position: position })] }) })] }));
});
//# sourceMappingURL=SpatialChatThread.js.map